import BaseModelAPI from '../BaseModelAPI';

export default class CompanyInfoList extends BaseModelAPI {

	static entity = 'companyinfolist'
	static entityName = 'companyinfo';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
